






























import { Component, Vue, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import Loading from '@/components/Loading.vue';

@Component({
  components: { Loading },
})
export default class LeaderboardRankings extends Vue {
  @Prop({ required: true, type: String })
  public leaderboardId!: string;

  @Prop({ default: 'Score', type: String })
  public scoreLabel!: string;

  public rankingsQuery = gql`
    query LeaderboardRankings($leaderboardId: ID!) {
      leaderboardRankings(leaderboardId: $leaderboardId) {
        name
        score
        homeCenterName
      }
    }
  `;
}
